<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/* #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */
#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale; */
  width:100%;
  height:100%;
  font-family: Noto Sans SC!important;
  -webkit-font-smoothing: Noto Sans SC!important;
  -moz-osx-font-smoothing: Noto Sans SC!important;
}
*{
  margin:0;
  padding:0;
}
html,body{
  width:100%;
  height:100%;
}
body{
	overflow: auto !important;
}
ul{list-style:none}
a{text-decoration: none;}
img{border:none;}

.clearf:after,
.clearf:before{
    content:"";
    display:block;
    clear:both;
}
button{
  cursor: pointer;
  outline: none;
}
.tool-tip {
  max-width: 560px;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue